export default "__VITE_ASSET__Djb5IXYF__"